import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Cookie, X } from 'lucide-react';

export default function CookieConsent() {
  const { lang } = useLanguage();
  const isAr = lang === 'ar';
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('gmre_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('gmre_cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('gmre_cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-0 left-0 right-0 z-[60] p-4 lg:p-6"
      style={{ direction: isAr ? 'rtl' : 'ltr' }}
    >
      <div className="max-w-4xl mx-auto bg-[#071E2C] border border-[#C9D6D9]/15 rounded-2xl p-5 lg:p-6 shadow-2xl backdrop-blur-xl">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Cookie className="w-8 h-8 text-[#C9A84C] flex-shrink-0 hidden sm:block" />
          <div className="flex-1">
            <p className="text-white text-sm font-medium mb-1">
              {isAr ? 'نستخدم ملفات تعريف الارتباط' : 'We use cookies'}
            </p>
            <p className="text-white/50 text-xs leading-relaxed">
              {isAr
                ? 'نستخدم ملفات تعريف الارتباط الأساسية والتحليلية لتحسين تجربتك. يمكنك قراءة المزيد في '
                : 'We use essential and analytics cookies to improve your experience. Learn more in our '}
              <Link to="/privacy" className="text-[#C9A84C] hover:underline">
                {isAr ? 'سياسة الخصوصية' : 'Privacy Policy'}
              </Link>.
            </p>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <Button onClick={decline} variant="ghost" className="text-white/50 hover:text-white text-xs px-3 h-9">
              {isAr ? 'رفض' : 'Decline'}
            </Button>
            <Button onClick={accept} data-testid="cookie-accept-btn" className="bg-[#C9A84C] hover:bg-[#A68966] text-[#0B2F44] font-bold text-xs px-5 h-9">
              {isAr ? 'قبول' : 'Accept All'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
